import '../../../css/style.scss'
import '../../../css/theme/discord/style.css'
import {ClientI18nInitiation} from '../../../../shared/scripts/ClientI18n'
import {DiscordMountController} from './DiscordMountController'

class EntryDiscordMount {
    constructor() {
        void EntryDiscordMount.init()
    }

    static async init() {
        EntryDiscordMount.setSafeAreaInsets()

        await ClientI18nInitiation.init()
        new DiscordMountController()
    }

    private static setSafeAreaInsets() {
        const isAndroidUser = navigator.userAgent.includes('Android')
        if(!isAndroidUser) return

        const defaultSafeAreaInset = 75
        const safeAreaInset = Math.max(window.innerWidth - document.documentElement.clientWidth, defaultSafeAreaInset) + 'px'

        document.documentElement.style.setProperty('--safe-area-inset-right', safeAreaInset)
        document.documentElement.style.setProperty('--safe-area-inset-left', safeAreaInset)
    }
}

new EntryDiscordMount()
